import * as React from "react";
import 'date-fns';
import DateFnsUtils from '@date-io/date-fns';
import ruLocale from "date-fns/locale/ru";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";

function DatePicker(props) {
  return React.createElement(MuiPickersUtilsProvider, {
    utils: DateFnsUtils,
    locale: ruLocale
  }, React.createElement(DatePicker, Object.assign({}, props)));
}

export default DatePicker;